webpackJsonp([21,19],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(71);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _routes = __webpack_require__(137);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _vueRouter = __webpack_require__(337);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(336);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _store = __webpack_require__(140);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _components = __webpack_require__(136);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _museUi = __webpack_require__(251);
	
	var _museUi2 = _interopRequireDefault(_museUi);
	
	__webpack_require__(222);
	
	var _vueScroller = __webpack_require__(338);
	
	var _vueScroller2 = _interopRequireDefault(_vueScroller);
	
	var _resource = __webpack_require__(139);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _keys2.default)(_components2.default).forEach(function (key) {
	  var name = key.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  _vue2.default.component('v' + name, _components2.default[key]);
	  console.log(key + ' ' + 'reg:' + name + _components2.default[key]);
	});
	
	_vue2.default.use(_museUi2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueScroller2.default);
	var router = new _vueRouter2.default({ routes: _routes2.default });
	router.beforeEach(function (_ref, from, next) {
	  var meta = _ref.meta,
	      path = _ref.path;
	
	  console.log('next: ' + path);
	  var _meta$auth = meta.auth,
	      auth = _meta$auth === undefined ? true : _meta$auth;
	
	  var isLogin = Boolean(_store2.default.state.user.userId);
	  if (auth && !isLogin && path !== '/login') {}
	  next();
	});
	window.resource = _resource2.default;
	window.$router = router;
	window.$store = _store2.default;
	new _vue2.default({
	  store: _store2.default,
	  router: router,
	  data: {
	    eventHub: new _vue2.default()
	  }
	}).$mount('#app');

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  setTempParam: function setTempParam(param) {
	    window.temporaryParam = param;
	  },
	  getTempParam: function getTempParam() {
	    return window.temporaryParam;
	  },
	  delayBack: function delayBack() {
	    setTimeout(function () {
	      $router.back();
	    }, 1000);
	  },
	  setTitle: function setTitle(title) {
	    document.getElementsByTagName('title')[0].innerHTML = title;
	  },
	  formatPrice: function formatPrice(number) {
	    return parseFloat(number / 100).toFixed(2) + '元';
	  },
	  checkTimeReached: function checkTimeReached(timeStamp) {
	    var now = new Date().getTime();
	    return timeStamp > 0 ? now > timeStamp : false;
	  },
	  showLoading: function showLoading(text) {
	    var mask = document.getElementById('mask-transparent');
	    mask.style.zIndex = 1000;
	    resetToastStyle();
	    var icon = document.getElementById('weui-toast-i');
	    icon.removeAttribute('class');
	    icon.setAttribute('class', 'weui-loading weui-icon_toast');
	    document.getElementById('toast-text').innerHTML = text === undefined ? '正在加载' : text;
	  },
	  hideLoading: function hideLoading() {
	    var mask = document.getElementById('mask-transparent');
	    mask.style.zIndex = -1;
	    var toast = document.getElementById('weui-toast');
	    toast.style.display = 'none';
	  },
	  showToast: function showToast(message, style) {
	    var _this = this;
	
	    var mask = document.getElementById('mask-transparent');
	    mask.style.zIndex = 1000;
	    var toast = document.getElementById('weui-toast');
	    resetToastStyle();
	    var icon = document.getElementById('weui-toast-i');
	    icon.removeAttribute('class');
	    if (style === 'success') {
	      icon.setAttribute('class', 'weui-icon-success-no-circle weui-icon_toast');
	    } else if (style === 'forbidden') {
	      icon.setAttribute('class', 'weui-icon-warn weui-icon_toast');
	    } else if (style === 'cancel') {
	      icon.setAttribute('class', 'weui-icon-cancel weui-icon_toast');
	    } else {
	      toast.removeAttribute('class');
	      toast.setAttribute('class', 'weui-toast weui-toast--text weui-toast--visible');
	    }
	    document.getElementById('toast-text').innerHTML = message === undefined ? '' : message;
	    console.log(message);
	    if (window.qizhiTimer) clearTimeout(this.qizhiTimer);
	    window.qizhiTimer = setTimeout(function () {
	      _this.hideLoading();
	    }, 2000);
	  },
	  hideToast: function hideToast() {
	    this.hideLoading();
	    if (window.qizhiTimer) clearTimeout(window.qizhiTimer);
	  },
	  dealwithAddress: function dealwithAddress(address, companyId) {
	    var addressList = address.split('|');
	    if (parseInt(companyId) === 8 || parseInt(companyId) === 9) {
	      addressList.splice(0, 1);
	      addressList.splice(2, 1);
	    }
	    return addressList.join(' ');
	  }
	};
	
	
	function resetToastStyle() {
	  var toast = document.getElementById('weui-toast');
	  toast.removeAttribute('class');
	  toast.setAttribute('class', 'weui-toast weui-toast--visible');
	  toast.style.display = 'block';
	}

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(62);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dealWithResult(data, resolve, reject) {
	  if (data.data.code && parseInt(data.data.code) === 100) {
	    resolve(data.data.data);
	  } else {
	    window.$router.replace;
	    reject(data.data.message);
	  }
	}
	
	function dealWithError(data, resolve, reject) {
	  reject(data.status + ' ' + data.statusText);
	}
	
	function post(url, body, token, param) {
	  return new _promise2.default(function (resolve, reject) {
	    _axios2.default.post('/vue' + url, body, { params: param, headers: { 'token': !token ? '' : token, 'locale': 'zh_CN' } }).then(function (response) {
	      dealWithResult(response, resolve, reject);
	    }, function (response) {
	      dealWithError(response, resolve, reject);
	    });
	  });
	}
	
	function get(url, param, token) {
	  return new _promise2.default(function (resolve, reject) {
	    _axios2.default.get('/vue' + url, { params: param, headers: { 'token': !token ? '' : token, 'locale': 'zh_CN' } }).then(function (response) {
	      dealWithResult(response, resolve, reject);
	    }).catch(function (error) {
	      dealWithError(error, resolve, reject);
	    });
	  });
	}
	
	function deleted(url, param, token) {
	  return new _promise2.default(function (resolve, reject) {
	    _axios2.default.delete('/vue' + url, { params: param, headers: { 'token': !token ? '' : token, 'locale': 'zh_CN' } }).then(function (response) {
	      dealWithResult(response, resolve, reject);
	    }, function (response) {
	      dealWithError(response, resolve, reject);
	    });
	  });
	}
	
	exports.default = {
	  activateAccount: function activateAccount(param) {
	    return post('/activateAccount', param);
	  },
	  login: function login(info) {
	    return post('/login', info);
	  },
	  getPeriods: function getPeriods(userInfo) {
	    return get('/period', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId });
	  },
	  getHomePage: function getHomePage(userInfo) {
	    return get('/getHomePage', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId, hallId: userInfo.hallId });
	  },
	  getRecords: function getRecords(userInfo, type, page) {
	    return get('/getRecords', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId, type: type, page: page });
	  },
	  getOrderDetail: function getOrderDetail(userInfo, orderId) {
	    return get('/getOrderDetail', { token: userInfo.token, company: userInfo.companyId, user: userInfo.userId, orderId: orderId });
	  },
	  getBalance: function getBalance(userInfo) {
	    return get('/balance', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId });
	  },
	  getPeriodMenus: function getPeriodMenus(userInfo, hallId, periodPlanId) {
	    return get('/getPeriodMenus?userId=' + userInfo.userId + '&companyId=' + userInfo.companyId, { hallId: hallId, periodPlanId: periodPlanId }, userInfo.token);
	  },
	  addOrder: function addOrder(userInfo, param) {
	    return post('/addOrder', param, userInfo.token);
	  },
	  getPayInfo: function getPayInfo(userInfo, orderIds, payType, companyId) {
	    return get('/pay?user=' + userInfo.userId + '&openId=' + userInfo.openId + '&orderIds=' + orderIds + '&payType=' + payType + '&companyId=' + companyId, {}, userInfo.token);
	  },
	  modifyPwd: function modifyPwd(param) {
	    return get('/modifyPwd', param, param.token);
	  },
	  deleteOrder: function deleteOrder(userInfo, orderId) {
	    return deleted('/deleteOrder', { token: userInfo.token, companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId });
	  },
	  getAddressList: function getAddressList(companyId) {
	    return get('/getAddressList', { companyId: companyId });
	  },
	  transferBedWithAddress: function transferBedWithAddress(userInfo, orderId, address) {
	    return get('/transferBedWithAddress', { companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId, address: address }, userInfo.token);
	  },
	  getPatientInfo: function getPatientInfo(userInfo, patientNo) {
	    return get('/getPatientInfo', { userId: userInfo.userId, companyId: userInfo.companyId, patientNo: patientNo }, userInfo.token);
	  }
	};

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CLEAR_ORDERED_DISH_BY_PERIOD_ID = exports.COMMIT_ORDER = exports.ALL_PERIOD_PLAN_DISHES = exports.CHANGE_DISH_COUNT = exports.UPDATE_MENU_DISHES = exports.GET_PERIODS = undefined;
	
	var _set = __webpack_require__(144);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _map = __webpack_require__(142);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _slicedToArray2 = __webpack_require__(145);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(70);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(33);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutations, _actions;
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _utils = __webpack_require__(8);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_PERIODS = exports.GET_PERIODS = 'GET_PERIODS';
	var UPDATE_MENU_DISHES = exports.UPDATE_MENU_DISHES = 'UPDATE_MENU_DISHES';
	var CHANGE_DISH_COUNT = exports.CHANGE_DISH_COUNT = 'CHANGE_DISH_COUNT';
	var ALL_PERIOD_PLAN_DISHES = exports.ALL_PERIOD_PLAN_DISHES = 'allPeriodPlanDishes';
	var COMMIT_ORDER = exports.COMMIT_ORDER = 'COMMIT_ORDER';
	var CLEAR_ORDERED_DISH_BY_PERIOD_ID = exports.CLEAR_ORDERED_DISH_BY_PERIOD_ID = 'CLEAR_ORDERED_DISH_BY_PERIOD_ID';
	exports.default = {
	  state: { allPeriods: [], allDishes: JSON.parse(localStorage.getItem(ALL_PERIOD_PLAN_DISHES)) || {} },
	  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, GET_PERIODS, function (state, periods) {
	    (0, _assign2.default)(state, periods);
	  }), (0, _defineProperty3.default)(_mutations, UPDATE_MENU_DISHES, function (state, data) {
	    _vue2.default.set(state.allDishes, data.periodPlanId + '', data.data);
	    localStorage.setItem(ALL_PERIOD_PLAN_DISHES, (0, _stringify2.default)(state.allDishes));
	  }), _mutations),
	  actions: (_actions = {
	    getSelectedDish: function getSelectedDish(_ref, periodPlanId) {
	      var commit = _ref.commit,
	          state = _ref.state;
	
	      return new _promise2.default(function (resolve, reject) {
	        var selectedDish = [];
	        if (state.allDishes[periodPlanId] === undefined || !Array.isArray(state.allDishes[periodPlanId])) return [];
	        state.allDishes[periodPlanId].forEach(function (cate) {
	          cate.items.forEach(function (dish) {
	            if (dish.count > 0) {
	              selectedDish.push(dish);
	            }
	          });
	        });
	        resolve(JSON.parse((0, _stringify2.default)(selectedDish)));
	      }, function (data) {
	        reject(data);
	      });
	    }
	  }, (0, _defineProperty3.default)(_actions, GET_PERIODS, function (_ref2, user) {
	    var commit = _ref2.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getPeriods(user).then(function (data) {
	        commit(GET_PERIODS, data);
	        resolve();
	      }, function (data) {
	        commit(GET_PERIODS, {});
	        reject(data);
	      });
	    });
	  }), (0, _defineProperty3.default)(_actions, UPDATE_MENU_DISHES, function (_ref3, param) {
	    var state = _ref3.state,
	        commit = _ref3.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getPeriodMenus(param.user, param.hallId, param.periodPlanId).then(function (data) {
	        var dishes = data.cates.sort(function (a, b) {
	          return a.catePriority - b.catePriority;
	        });
	
	        dishes.forEach(function (cate, cateIndex) {
	          cate.items.forEach(function (dish, dishIndex) {
	            dish.cateIndex = cateIndex;
	            dish.dishIndex = dishIndex;
	            dish.periodPlanId = param.periodPlanId;
	            dish.tags.forEach(function (tag) {
	              if (!_utils2.default.checkTimeReached(cate.cateEndTime) && tag.limitType === 1 && tag.checkType === 1) {
	                if (tag.userLeastAmount > 0) {
	                  dish.count = tag.userLeastAmount;
	                  dish.userLeastAmount = tag.userLeastAmount;
	                  dish.decDisabled = true;
	                }
	              }
	            });
	          });
	        });
	
	        var selectedDish = getSelectedDish(state, param.periodPlanId);
	        if (selectedDish.length > 0) {
	          selectedDish.forEach(function (d) {
	            dishes.forEach(function (cate) {
	              if (!_utils2.default.checkTimeReached(cate.cateEndTime)) {
	                cate.items.forEach(function (dish) {
	                  if (dish.itemId === d.itemId) {
	                    dish.count = d.count;
	                    dish.addDisabled = d.addDisabled ? d.addDisabled : undefined;
	                    dish.decDisabled = d.decDisabled ? d.decDisabled : undefined;
	                  }
	                });
	              }
	            });
	          });
	        }
	        commit(UPDATE_MENU_DISHES, { periodPlanId: param.periodPlanId, data: dishes });
	        resolve();
	      }, function (data) {
	        commit(UPDATE_MENU_DISHES, { periodPlanId: param.periodPlanId, data: {} });
	        reject(data);
	      });
	    });
	  }), (0, _defineProperty3.default)(_actions, CHANGE_DISH_COUNT, function (_ref4, param) {
	    var commit = _ref4.commit,
	        state = _ref4.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      var allDishes = JSON.parse((0, _stringify2.default)(state.allDishes));
	      var periodPlanId = param.dish.periodPlanId;
	      var cateIndex = param.dish.cateIndex;
	      var dishIndex = param.dish.dishIndex;
	      var cate = allDishes[periodPlanId][cateIndex];
	      var dish = allDishes[periodPlanId][cateIndex].items[dishIndex];
	      var needReject = false;
	      var rejectString = '';
	      if (param.optr === 'a') {
	        if (param.count > dish.limit) {
	          dish.addDisabled = true;
	          needReject = true;
	          rejectString = '超过库存限制';
	        }
	
	        if (_utils2.default.checkTimeReached(cate.cateEndTime)) {
	          needReject = true;
	          rejectString = '该类目菜品超出预点时间';
	        }
	
	        var singleAmount = checkSingleDishLimitAmount(dish);
	        if (singleAmount > 0) {
	          if (param.count >= singleAmount) {
	            dish.addDisabled = true;
	            if (param.count > singleAmount) {
	              needReject = true;
	              rejectString = dish.itemName + '\u9650\u70B9' + singleAmount + '\u4EFD';
	            }
	          }
	        }
	
	        var scopeCheckTips = checkScopeLimit(param, allDishes[periodPlanId], dish);
	        if (scopeCheckTips.length > 0) {
	          commit(UPDATE_MENU_DISHES, { periodPlanId: periodPlanId, data: allDishes[periodPlanId] });
	          needReject = true;
	          rejectString = scopeCheckTips;
	        }
	      } else if (param.optr === 'd') {
	        var _singleAmount = checkSingleDishLeastAmount(dish);
	        if (_singleAmount > 0) {
	          if (param.count <= _singleAmount) {
	            dish.decDisabled = true;
	            if (param.count < _singleAmount) {
	              needReject = true;
	              rejectString = dish.itemName + '\u81F3\u5C11\u9700\u70B9' + _singleAmount + '\u4EFD';
	            }
	          }
	        }
	        checkScopeLimit(param, allDishes[periodPlanId], dish);
	      }
	      if (needReject) {
	        reject(rejectString);
	      } else {
	        if (param.optr === 'a') {
	          dish.decDisabled = false;
	        } else {
	          dish.addDisabled = false;
	        }
	        allDishes[periodPlanId][cateIndex].items[dishIndex].count = param.count;
	        commit(UPDATE_MENU_DISHES, { periodPlanId: periodPlanId, data: allDishes[periodPlanId] });
	        resolve();
	      }
	    });
	  }), (0, _defineProperty3.default)(_actions, COMMIT_ORDER, function (_ref5, param) {
	    var commit = _ref5.commit,
	        state = _ref5.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      var needReject = false;
	      var rejectString = '';
	      var allowForceCommit = true;
	      var allDishes = JSON.parse((0, _stringify2.default)(state.allDishes));
	
	      var singleDishRemind = checkSingleDishRemind(param, allDishes);
	      if (singleDishRemind.length > 0) {
	        needReject = true;
	        rejectString = singleDishRemind;
	        allowForceCommit = true;
	      }
	
	      var scopeDishRemind = checkScopeDishRemind(param, allDishes);
	      if (scopeDishRemind.length > 0) {
	        needReject = true;
	        rejectString = scopeDishRemind;
	        allowForceCommit = true;
	      }
	
	      var scopeCheckTips = checkScopeLeast(param, allDishes);
	      if (scopeCheckTips.length > 0) {
	        needReject = true;
	        rejectString = scopeCheckTips;
	        allowForceCommit = false;
	      }
	      if (needReject) {
	        reject({ string: rejectString, allowForceCommit: allowForceCommit });
	      } else {
	        resolve();
	      }
	    });
	  }), (0, _defineProperty3.default)(_actions, CLEAR_ORDERED_DISH_BY_PERIOD_ID, function (_ref6, periodPlanId) {
	    var commit = _ref6.commit,
	        state = _ref6.state;
	
	    if (state.allDishes[periodPlanId] !== undefined) {
	      var dishes = JSON.parse((0, _stringify2.default)(state.allDishes[periodPlanId]));
	      dishes.forEach(function (cate) {
	        if (cate.items.length > 0) {
	          cate.items.forEach(function (i) {
	            i.count = 0;
	          });
	        }
	      });
	      commit(UPDATE_MENU_DISHES, { periodPlanId: periodPlanId, data: dishes });
	    }
	  }), _actions)
	};
	
	function checkSingleDishRemind(param, allDishes) {
	  var tips = '';
	  var commonDishes = allDishes[param.periodPlanId];
	  var nutritionDishes = allDishes[param.nutritionPeriodId];
	  commonDishes.forEach(function (cate) {
	    cate.items.forEach(function (dish) {
	      dish.tags.forEach(function (tag) {
	        if (tag.limitType === 3 && tag.checkType === 1) {
	          if (dish.count === undefined || dish.count === 0) {
	            if (tips.length > 0) {
	              tips = tips + '\u3001"' + dish.itemName + '"';
	            } else {
	              tips = '\u60A8\u8FD8\u6CA1\u6709\u70B9"' + dish.itemName + '"';
	            }
	          }
	        }
	      });
	    });
	  });
	  if (Array.isArray(nutritionDishes) && nutritionDishes.length > 0) {
	    nutritionDishes.forEach(function (cate) {
	      cate.items.forEach(function (dish) {
	        dish.tags.forEach(function (tag) {
	          if (tag.limitType === 3 && tag.checkType === 1) {
	            if (dish.count === undefined || dish.count === 0) {
	              if (tips.length > 0) {
	                tips = tips + '\u3001"' + dish.itemName + '"';
	              } else {
	                tips = '\u60A8\u8FD8\u6CA1\u6709\u70B9"' + dish.itemName + '"';
	              }
	            }
	          }
	        });
	      });
	    });
	  }
	  if (tips.length > 0) {
	    tips = tips + '\uFF0C\u662F\u5426\u786E\u8BA4\u7ED3\u7B97\uFF1F';
	  }
	  return tips;
	}
	
	function checkScopeDishRemind(param, allDishes) {
	  var tips = '';
	  var map = makeTagDishMap(allDishes[param.periodPlanId], 3, 2);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(map.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	          tag = _step$value[0],
	          dishes = _step$value[1];
	
	      var totalCount = dishes.reduce(function (acc, cur) {
	        return acc + cur.count;
	      }, 0);
	      if (totalCount === 0) {
	        if (tips.length === 0) {
	          tips = '\u60A8\u8FD8\u6CA1\u6709\u70B9"' + tag.tagName + '"';
	        } else {
	          tips = tips + '\n\u60A8\u8FD8\u6CA1\u6709\u70B9"' + tag.tagName + '"';
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  map = makeTagDishMap(allDishes[param.nutritionPeriodId], 3, 2);
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = (0, _getIterator3.default)(map.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
	          tag = _step2$value[0],
	          dishes = _step2$value[1];
	
	      var _totalCount = dishes.reduce(function (acc, cur) {
	        return acc + cur.count;
	      }, 0);
	      if (_totalCount === 0) {
	        if (tips.length === 0) {
	          tips = '\u60A8\u8FD8\u6CA1\u6709\u70B9"' + tag.tagName + '"';
	        } else {
	          tips = tips + ';\n        \u60A8\u8FD8\u6CA1\u6709\u70B9"' + tag.tagName + '"';
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  if (tips.length > 0) {
	    tips = tips + '\uFF0C\u662F\u5426\u786E\u8BA4\u7ED3\u7B97\uFF1F';
	  }
	  return tips;
	}
	
	function checkSingleDishLimitAmount(dish) {
	  var result = 999;
	  dish.tags.forEach(function (tag) {
	    if (tag.limitType === 1 && tag.checkType === 1) {
	      if (tag.userLimitAmount < result) {
	        result = tag.userLimitAmount;
	      }
	    }
	  });
	  return result;
	}
	
	function checkSingleDishLeastAmount(dish) {
	  var result = 0;
	  dish.tags.forEach(function (tag) {
	    if (tag.limitType === 1 && tag.checkType === 1) {
	      if (tag.userLeastAmount !== 0 && tag.userLeastAmount > result) {
	        result = tag.userLeastAmount;
	      }
	    }
	  });
	  return result;
	}
	
	function makeTagDishMap(allDishes, limitType, checkType) {
	  if (!Array.isArray(allDishes) || allDishes.length === 0) {
	    return new _map2.default();
	  }
	  var map = new _map2.default();
	  var set = new _set2.default();
	  allDishes.forEach(function (cate) {
	    cate.items.forEach(function (dish) {
	      dish.tags.forEach(function (tag) {
	        if (tag.limitType === limitType && tag.checkType === checkType) {
	          var exist = false;
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = (0, _getIterator3.default)(set.values()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var item = _step3.value;
	
	              if (item.tagId === tag.tagId) {
	                exist = true;
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          if (exist === false) {
	            set.add(tag);
	          }
	        }
	      });
	    });
	  });
	  var _iteratorNormalCompletion4 = true;
	  var _didIteratorError4 = false;
	  var _iteratorError4 = undefined;
	
	  try {
	    var _loop = function _loop() {
	      var item = _step4.value;
	
	      var dishArr = [];
	      allDishes.forEach(function (cate) {
	        cate.items.forEach(function (dish) {
	          dish.tags.forEach(function (tag) {
	            if (tag.tagId === item.tagId) {
	              dishArr.push(dish);
	            }
	          });
	        });
	      });
	      map.set(item, dishArr);
	    };
	
	    for (var _iterator4 = (0, _getIterator3.default)(set.values()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	      _loop();
	    }
	  } catch (err) {
	    _didIteratorError4 = true;
	    _iteratorError4 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion4 && _iterator4.return) {
	        _iterator4.return();
	      }
	    } finally {
	      if (_didIteratorError4) {
	        throw _iteratorError4;
	      }
	    }
	  }
	
	  return map;
	}
	
	function checkScopeLimit(param, allDishes, origDish) {
	  var map = makeTagDishMap(allDishes, 1, 2);
	  var tips = '';
	  if (param.optr === 'a') {
	    var canBeAddCount = true;
	    origDish.tags.forEach(function (dishTag) {
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = (0, _getIterator3.default)(map.entries()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var _step5$value = (0, _slicedToArray3.default)(_step5.value, 2),
	              tag = _step5$value[0],
	              dishes = _step5$value[1];
	
	          if (dishTag.tagId === tag.tagId) {
	            var totalCount = dishes.reduce(function (acc, cur) {
	              return acc + cur.count;
	            }, 0);
	            if (totalCount > tag.userLimitAmount - 1) {
	              canBeAddCount = false;
	              tips = '"' + tag.tagName + '"\u7C7B\u83DC\u54C1\u6570\u91CF\u4E0D\u53EF\u8D85\u8FC7' + tag.userLimitAmount + '\u4EFD';
	            } else if (totalCount === tag.userLimitAmount - 1) {
	              dishes.forEach(function (dish) {
	                dish.addDisabled = true;
	              });
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	    });
	    if (canBeAddCount) {
	      origDish.count++;
	    }
	  } else if (param.optr === 'd') {
	    origDish.tags.forEach(function (dishTag) {
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = (0, _getIterator3.default)(map.entries()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var _step6$value = (0, _slicedToArray3.default)(_step6.value, 2),
	              tag = _step6$value[0],
	              dishes = _step6$value[1];
	
	          if (dishTag.tagId === tag.tagId) {
	            dishes.forEach(function (dish) {
	              dish.addDisabled = false;
	            });
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    });
	  }
	  return tips;
	}
	function checkScopeLeast(param, allDishes) {
	  var tips = '';
	  var map = makeTagDishMap(allDishes[param.periodPlanId], 1, 2);
	  var _iteratorNormalCompletion7 = true;
	  var _didIteratorError7 = false;
	  var _iteratorError7 = undefined;
	
	  try {
	    for (var _iterator7 = (0, _getIterator3.default)(map.entries()), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	      var _step7$value = (0, _slicedToArray3.default)(_step7.value, 2),
	          tag = _step7$value[0],
	          dishes = _step7$value[1];
	
	      var totalCount = dishes.reduce(function (acc, cur) {
	        return acc + cur.count;
	      }, 0);
	      if (totalCount < tag.userLeastAmount) {
	        tips = '"' + tag.tagName + '"\u7C7B\u83DC\u54C1\u6570\u91CF\u81F3\u5C11\u70B9' + tag.userLeastAmount + '\u4EFD';
	      }
	    }
	  } catch (err) {
	    _didIteratorError7 = true;
	    _iteratorError7 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion7 && _iterator7.return) {
	        _iterator7.return();
	      }
	    } finally {
	      if (_didIteratorError7) {
	        throw _iteratorError7;
	      }
	    }
	  }
	
	  map = makeTagDishMap(allDishes[param.nutritionPeriodId], 1, 2);
	  var _iteratorNormalCompletion8 = true;
	  var _didIteratorError8 = false;
	  var _iteratorError8 = undefined;
	
	  try {
	    for (var _iterator8 = (0, _getIterator3.default)(map.entries()), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	      var _step8$value = (0, _slicedToArray3.default)(_step8.value, 2),
	          tag = _step8$value[0],
	          dishes = _step8$value[1];
	
	      var _totalCount2 = dishes.reduce(function (acc, cur) {
	        return acc + cur.count;
	      }, 0);
	      if (_totalCount2 < tag.userLeastAmount) {
	        tips = '"' + tag.tagName + '"\u7C7B\u83DC\u54C1\u6570\u91CF\u81F3\u5C11\u70B9' + tag.userLeastAmount + '\u4EFD';
	      }
	    }
	  } catch (err) {
	    _didIteratorError8 = true;
	    _iteratorError8 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion8 && _iterator8.return) {
	        _iterator8.return();
	      }
	    } finally {
	      if (_didIteratorError8) {
	        throw _iteratorError8;
	      }
	    }
	  }
	
	  return tips;
	}
	function getSelectedDish(state, periodPlanId) {
	  var selectedDish = [];
	  if (state.allDishes[periodPlanId] === undefined || !Array.isArray(state.allDishes[periodPlanId])) return [];
	  state.allDishes[periodPlanId].forEach(function (cate) {
	    cate.items.forEach(function (dish) {
	      if (dish.count > 0) {
	        selectedDish.push(dish);
	      }
	    });
	  });
	  return JSON.parse((0, _stringify2.default)(selectedDish));
	}

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UPDATE_PATIENT_INFO = exports.WRITE_USER_INFO = exports.USER_SIGNOUT = exports.USER_SIGNIN = undefined;
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(33);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(71);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _mutations, _actions;
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var USER_SIGNIN = exports.USER_SIGNIN = 'USER_SIGNIN';var USER_SIGNOUT = exports.USER_SIGNOUT = 'USER_SIGNOUT';var WRITE_USER_INFO = exports.WRITE_USER_INFO = 'WRITE_USER_INFO';var UPDATE_PATIENT_INFO = exports.UPDATE_PATIENT_INFO = 'UPDATE_PATIENT_INFO';exports.default = {
	  state: JSON.parse(sessionStorage.getItem('user')) || {},
	  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, USER_SIGNIN, function (state, user) {
	    sessionStorage.setItem('user', (0, _stringify2.default)(user));
	    (0, _assign2.default)(state, user);
	  }), (0, _defineProperty3.default)(_mutations, USER_SIGNOUT, function (state) {
	    sessionStorage.removeItem('user');
	    (0, _keys2.default)(state).forEach(function (k) {
	      return _vue2.default.delete(state, k);
	    });
	  }), (0, _defineProperty3.default)(_mutations, UPDATE_PATIENT_INFO, function (state, data) {
	    var user = JSON.parse((0, _stringify2.default)(state));
	    user.address = data.patientBed;
	    user.patientIndicateTags = data.patientIndicateTags;
	    user.bedPatientName = data.patientName;
	    user.patientSpecialDiet = data.patientSpecialDiet;
	    sessionStorage.setItem('user', (0, _stringify2.default)(user));
	    (0, _assign2.default)(state, user);
	  }), _mutations),
	  actions: (_actions = {}, (0, _defineProperty3.default)(_actions, USER_SIGNIN, function (_ref, user) {
	    var commit = _ref.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.login(user).then(function (data) {
	        data.hallId = 13;
	        commit(USER_SIGNIN, data);
	        resolve();
	      }, function (data) {
	        commit(USER_SIGNOUT);
	        reject(data);
	      });
	    });
	  }), (0, _defineProperty3.default)(_actions, USER_SIGNOUT, function (_ref2) {
	    var commit = _ref2.commit;
	
	    commit(USER_SIGNOUT);
	  }), (0, _defineProperty3.default)(_actions, WRITE_USER_INFO, function (_ref3, user) {
	    var commit = _ref3.commit;
	
	    commit(USER_SIGNIN, user);
	  }), (0, _defineProperty3.default)(_actions, UPDATE_PATIENT_INFO, function (_ref4, patientNo) {
	    var commit = _ref4.commit,
	        state = _ref4.state;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getPatientInfo(state, patientNo).then(function (data) {
	        commit(UPDATE_PATIENT_INFO, data);
	        resolve();
	      }, function (data) {
	        reject(data);
	      });
	    });
	  }), _actions)
	};

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GET_HOMEPAGE = undefined;
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(33);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_HOMEPAGE = exports.GET_HOMEPAGE = 'GET_HOMEPAGE';
	
	exports.default = {
	  state: { dayPeriods: [], banners: [] },
	  mutations: (0, _defineProperty3.default)({}, GET_HOMEPAGE, function (state, periods) {
	    (0, _assign2.default)(state, periods);
	  }),
	  actions: (0, _defineProperty3.default)({}, GET_HOMEPAGE, function (_ref, user) {
	    var commit = _ref.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getHomePage(user).then(function (data) {
	        commit(GET_HOMEPAGE, data);
	        resolve();
	      }, function (data) {
	        commit(GET_HOMEPAGE, { dayPeriods: [], banners: [] });
	        reject(data);
	      });
	    });
	  })
	};

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GET_RECORDS = undefined;
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(33);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _api = __webpack_require__(10);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_RECORDS = exports.GET_RECORDS = 'GET_RECORDS';
	var finished = 'finished';
	var unfinished = 'unfinished';
	exports.default = {
	  state: { finishedOrders: [], unfinishedOrders: [] },
	  mutations: (0, _defineProperty3.default)({}, GET_RECORDS, function (state, data) {
	    if (data.param === undefined) {
	      return;
	    }
	    if (data.param.type === finished) {
	      if (data.param.page === 1) {
	        _vue2.default.set(state, 'finishedOrders', data.data.orders);
	      } else {
	        var oldOrders = JSON.parse((0, _stringify2.default)(state.finishedOrders));
	        Array.prototype.push.apply(oldOrders, data.data.orders);
	        _vue2.default.set(state, 'finishedOrders', oldOrders);
	      }
	    } else if (data.param.type === unfinished) {
	      if (data.param.page === 1) {
	        _vue2.default.set(state, 'unfinishedOrders', data.data.orders);
	      } else {
	        var _oldOrders = JSON.parse((0, _stringify2.default)(state.unfinishedOrders));
	        Array.prototype.push.apply(_oldOrders, data.data.orders);
	        _vue2.default.set(state, 'unfinishedOrders', _oldOrders);
	      }
	    }
	  }),
	  actions: (0, _defineProperty3.default)({}, GET_RECORDS, function (_ref, param) {
	    var commit = _ref.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _api2.default.getRecords(param.user, param.param.type, param.param.page).then(function (data) {
	        commit(GET_RECORDS, { data: data, param: param.param });
	        resolve();
	      }, function (data) {
	        commit(GET_RECORDS, { finishedOrders: [], unfinishedOrders: [] });
	        reject(data);
	      });
	    });
	  })
	};

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      showLoading: false
	    };
	  },
	  created: function created() {
	    window.$app = this;
	  },
	  mounted: function mounted() {
	    var loading = document.getElementById('bowl-wrapper');
	    if (loading.parentNode) {
	      loading.parentNode.removeChild(loading);
	    }
	  }
	};

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    title: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(291);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { header: _header2.default };

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _App = __webpack_require__(288);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  path: '/',
	  component: _App2.default,
	  children: [{
	    path: '/initialAddress',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(59)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/fillBedNo',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(59)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/register',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(307)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/login',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(91)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/menu',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(298)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/confirmPatientInfo',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(295)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/confirmOrder',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(297)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/pay',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(299)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/wxPayResult',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(300)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/initialAddress',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(59)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/description',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(293)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'orderInfo',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(302)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '/home',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(296)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    children: [{
	      path: 'fromWE',
	      meta: { auth: false },
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(90)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'periods',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(90)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'records',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(305)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'my',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(301)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'personInfo',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(303)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'personSetting',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(304)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'changePassword',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(294)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'transBed',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(306)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }]
	  }, {
	    path: '/',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(91)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '*',
	    meta: { auth: false },
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(308)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}];

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  getKeys: function getKeys(str) {
	    return str.split(',');
	  },
	
	  keysToStr: function keysToStr(arr) {
	    return arr.joni(',');
	  },
	  orderStatus: {
	    'NOT_PAY': '未支付',
	    'NOT_CONSUME': '未消费',
	    'CONSUMED': '已消费',
	    'REFUNDING': '退款中',
	    'CANCELED': '已取消',
	    'REFUND': '已退款',
	    'COMMENTED': '已消费',
	    'CLOSED': '已关闭'
	  },
	  receiveStatus: {
	    '0': '',
	    '2': '(赊账)'
	  },
	  payType: {
	    'alipay': '支付宝',
	    'weixinpay': '微信支付',
	    'unkonwn': '暂无'
	  },
	  tagType: {
	    label: '标签基本类型',
	    values: {
	      1: '普通标签',
	      2: '营养标签'
	    }
	  },
	  limitType: {
	    label: '标签限制提醒类型',
	    values: {
	      0: '无限制无提醒',
	      1: '限制',
	      3: '提醒'
	    }
	  },
	  checkType: {
	    label: '标签范围',
	    values: {
	      1: '单品',
	      2: '范围'
	    }
	  }
	};

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(6);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _user = __webpack_require__(32);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _period = __webpack_require__(23);
	
	var _period2 = _interopRequireDefault(_period);
	
	var _homepage = __webpack_require__(68);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _records = __webpack_require__(69);
	
	var _records2 = _interopRequireDefault(_records);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  strict: ("production") !== 'production',
	  modules: {
	    user: _user2.default,
	    period: _period2.default,
	    homepage: _homepage2.default,
	    records: _records2.default
	  }
	});

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(241)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(111),
	  /* template */
	  __webpack_require__(327),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(224)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(115),
	  /* template */
	  __webpack_require__(309),
	  /* scopeId */
	  "data-v-00b7cee9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "item left"
	  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._t("right")], 2)])
	},staticRenderFns: []}

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view', {
	    staticClass: "view"
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.adc14aef6ce70bb6a608.js